<div class="heading">
  <span i18n="@@S_DEVICE_HEALTH_CHECK">Device Health Check</span>
</div>
<div class="vehicle-details" [ngClass]="{ 'vehicle-details__updating': isUpdating$ | async }">
  <span *ngIf="isVehicleOrPoweredAsset" [fmTooltip]="statusItem?.vehicleName" [showTooltipIfOverflow]="true" class="vehicle-details__name"
    >{{ statusItem?.vehicleName }}
  </span>
  <span *ngIf="isNonPoweredAsset" [fmTooltip]="statusItem?.name" [showTooltipIfOverflow]="true" class="vehicle-details__name"
    >{{ statusItem?.name }}
  </span>
  <span class="vehicle-details__update">
    <span i18n="@@S_LAST_UPDATE">Last Update:</span> {{ statusItem?.lastUpdateForDisplay }} •
    <span class="vehicle-details__formatted-date">
      <fm-date-ago-display [date]="lastUpdateDate"></fm-date-ago-display>
    </span>
  </span>
  <ng-container *ngTemplateOutlet="status"></ng-container>
  <span *ngIf="statusItem?.address" class="vehicle-details__location"
    ><span i18n="@@S_LAST_LOCATION">Last location:</span><span> {{ statusItem?.address }}</span></span
  >
  <span class="vehicle-details__box-esn"
    ><span i18n="@@S_TRACKER_TYPE">Tracker type:</span><span a7s-id="device-health-check-tracker-type"> {{ boxType }}</span></span
  >
  <span class="vehicle-details__box-esn"
    ><span i18n="@@S_ESN_FULL">Electronic serial number:</span><span a7s-id="device-health-check-esn"> {{ esn }}</span></span
  >
</div>

<fm-tabs *ngIf="!isNonPoweredAsset && isPingSupported; else deviceHealthCheck" [shouldFitTabs]="true" class="device-health-check-tabs">
  <fmTab
    heading="Restart"
    i18n-heading="@@S_LIVE_MAP_DHC_RESTART_TAB_TITLE"
    ariaLabelName="Restart"
    ariaLabelTranslation="@@S_LIVE_MAP_DHC_RESTART_TAB_TITLE"
    a7s-id="device-health-check-tabs-restart"
    id="device-health-check-tabs-restart"
  >
    <ng-template fmTabContent>
      <ng-container *ngTemplateOutlet="deviceHealthCheck"></ng-container>
    </ng-template>
  </fmTab>

  <fmTab
    heading="History"
    i18n-heading="@@S_LIVE_MAP_DHC_HISTORY_TAB_TITLE"
    ariaLabelName="History"
    ariaLabelTranslation="@@S_LIVE_MAP_DHC_HISTORY_TAB_TITLE"
    a7s-id="device-health-check-tabs-history"
    id="device-health-check-tabs-history"
  >
    <ng-template fmTabContent>
      <div class="scroll-container">
        <fm-device-health-check-history
          [history]="history"
          [historyLoading]="historyLoading"
          [userSettings]="userSettings"
          [vehicleId]="statusItem?.id"
        ></fm-device-health-check-history>
      </div>
    </ng-template>
  </fmTab>
</fm-tabs>

<ng-template #status>
  <ng-container *ngIf="!isAsset">
    <span i18n="@@S_LAST_STATUS">Last status:</span>
    <ng-container [ngSwitch]="statusItem?.status">
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Towing" i18n="@@S_TOWING">Towing</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Moving" i18n="@@S_MOVING">Moving</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Idling" i18n="@@S_IDLE">Idle</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Stopped" i18n="@@S_STOPPED">Stopped</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.LossOfSignal" i18n="@@S_LOSS_SIGNAL">Loss of signal</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Private" i18n="@@S_PRIVATE">Private</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Panic" i18n="@@S_PANIC">Panic</span>
      <span class="vehicle-details__status" *ngSwitchCase="EVehicleStatusType.Charging" i18n="@@S_CHARGING">Charging</span>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #deviceHealthCheck>
  <div class="scroll-container">
    <fm-device-health-check-ping-and-reset
      class="troubleshoot-section"
      [isAsset]="isAsset"
      [boxType]="boxType"
      [userSettings]="userSettings"
      [pingState]="pingState"
      [resetState]="resetState"
      [isPingSupported]="isPingSupported"
      [isNonPoweredAsset]="isNonPoweredAsset"
      (resetClicked)="resetClicked()"
      (showContactUs)="onShowContactUs($event)"
    ></fm-device-health-check-ping-and-reset>

    <fm-device-health-check-contact-support
      *ngIf="showContactSupportSection"
      class="contact-support-section"
      [liveChatParams]="liveChatParams"
      [userSettings]="userSettings"
    ></fm-device-health-check-contact-support>
  </div>
</ng-template>
